import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { Table } from "reactstrap";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { apReportSelector, fetchApReports, markReportAsPaid } from "slices/apReportSlice";
import { downloadConsolidatedInvoice } from "slices/apReportSlice";
import moment from "moment";
import { usePermissions } from "layouts/Admin";

function ApReportList() {

  const dispatch = useDispatch();
  const { reports, last_page: totalPages, loader, total, current_page, per_page: pageLength } =
    useSelector(apReportSelector);

  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({
    sortBy: "created_at",
    sortDirection: "desc",
  });

  useEffect(() => {
    console.log("🚀 ApReportList mounted");
    dispatch(fetchApReports(1));
  }, []);

  const { checkPermission } = usePermissions();
  const renderTableHeader = useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      dispatch(fetchApReports(1, { sortBy, sortDirection: dir, search: searchTerm }));
    };

    return (
      <tr>
        <th className="col-1">#</th>
        <th className='col-2'>
          <TableHeaderItem title="Created By" sortBy="created_by" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        <th className='col-2'>
          <TableHeaderItem title="Paid At" sortBy="paid_at" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        <th className='col-2'>
          <TableHeaderItem title="Paid By" sortBy="paid_by" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        <th className='col-2'>
          <TableHeaderItem title="Creation Date" sortBy="created_at" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        {(checkPermission('Paid Ap Reports') || checkPermission('Download Ap Reports')) && (
          <th className='col-2'>Actions</th>
        )}
      </tr>
    );
  }, [sortConfig, searchTerm]);

  // ===== TABLE BODY =====
  const renderTableContent = useCallback(() => {
    return (
      reports &&
      reports.map((report, index) => (
        <ReportRow
          key={report.id}
          report={report}
          index={index}
          current_page={current_page}
          pageLength={pageLength}
          onPaidClick={(id) => handlePaidClick(id)}
        />
      ))
    );
  }, [reports, current_page, pageLength]);

  // ===== Handle Paid Click =====
  const handlePaidClick = (id) => {
    dispatch(
      markReportAsPaid(id, (success, message) => {
        if (success) {
          toast.success(message);
          dispatch(fetchApReports(current_page)); // refresh list
        } else {
          toast.error(message);
        }
      })
    );
  };

  return (
    <ListLayout
      heading="AP Reports"
      title=""
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchApReports}
      selectedItems={selectedItems}
      addButtonDisabled={true}
      addformModal={false}
      renderAddLink={(callback) => ''}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder="Search AP Reports..."
      noOfItems={total}
      disableBootstrap={true}
    >
      {deleteModal && <ConfirmationModal onClose={() => setDeleteModal(false)} isOpen={deleteModal} />}
    </ListLayout>
  );
}

const ReportRow = ({ report, index, current_page, pageLength, onPaidClick }) => {
  const { checkPermission } = usePermissions();

  const dispatch = useDispatch();

  const handleDownload = async () => {
  dispatch(downloadConsolidatedInvoice(report.id));
};

  const serial = useMemo(() => index + 1 + (current_page - 1) * pageLength, [index, current_page, pageLength]);
  return (
    <tr>
      <td>{serial}</td>
      <td>{report?.created_by_user?.username ?? report?.created_by_user?.name}</td>
      <td>{report?.paid_at ? moment(report.paid_at).format('YYYY-MM-DD h:mm A') : '-'}</td>
      <td>{report?.paid_by_user?.username ?? report?.paid_by_user?.name ?? "-"}</td>
      <td>{report?.created_at ? moment(report.created_at).format('YYYY-MM-DD h:mm A') : '-'}</td>
      {(checkPermission('Paid Ap Reports') || checkPermission('Download Ap Reports')) && (
      <td className="d-flex align-items-center justify-content-end gap-1">
        {/* <Link className="main_button" onClick={() => onPaidClick(report?.id)}>
          Paid
        </Link> */}
        {report?.paid === 1 ? (
          ''
        ) : (
          checkPermission('Paid Ap Reports') && (
          <button className="main_button  green" onClick={() => onPaidClick(report?.id)}>
            Paid
          </button>)
        )}
         { checkPermission('Download Ap Reports') && (
        <button
          type="button"
          className="main_button"
          onClick={handleDownload}
          disabled={false}
          style={{ minWidth: 100 }}
        >
          {false ? "Downloading..." : "Download"}
        </button>)}
      </td>)}
    </tr>
  );
};

export default ApReportList;
